import React, { Component, useEffect, useState } from 'react'
import { loadLanguage, loadLanguages, loadCourse, saveCourse, loadTalents, uploadCourseImage } from '../utils/Network';
import { useHistory } from 'react-router';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';


import { Link } from 'react-router-dom';
import { BuildTalents, getDefaultName, isAdmin, mediaSrc, sortLanguages } from '../utils';
import SelectTalent from '../components/SelectTalent';
import SelectStatus from "../components/select/SelectStatus";
import SelectCountries from "../components/SelectCountries";
import SelectYear from '../components/SelectYear';
import SelectMonth from '../components/SelectMonth';
import SelectDay from '../components/SelectDay';
import { useRef } from 'react';
import Gallery from './Gallery';
import TabsWidget from './shared/dashboard/widgets/TabsWidget';

function usesRtlScript(name) {
    return name ? /[\u0600-\u06FF\u0700-\u074F]/.test(name) : false;
}

function prefersKurdishFont(name) {
    if (!name) return false;
    const n = name.toLowerCase();
    return usesRtlScript(name) || n.includes('kurd') || n.includes('کورد');
}


export default function CourseContent({ id }) {


    const history = useHistory();
    const today = new Date();
    const [names, setNames] = useState(null);
    const [status, setStatus] = useState(null);
    const [staffPreview, setStaffPreview] = useState(false);
    const [startdate, setStartDate] = useState({ year: today.getFullYear(), month: today.getMonth(), day: today.getDay() });
    const [enddate, setEndDate] = useState({ year: today.getFullYear(), month: today.getMonth() + 1, day: today.getDay() });;
    const [languages, setLanguages] = useState(null);
    const [gallery_modal_is_open, setGalleryModalIsOpen] = useState(false);

    const [start_year, setStartYear] = useState(null);
    const [start_month, setStartMonth] = useState(null);
    const [start_day, setStartDay] = useState(null);
    const [end_year, setEndYear] = useState(null);
    const [end_month, setEndMonth] = useState(null);
    const [end_day, setEndDay] = useState(null);

    const [talents, setTalents] = useState([]);
    const [country, setCountry] = useState(null);

    const [course_image, setCourseImage] = useState(null);
    const [activeLanguageTab, setActiveLanguageTab] = useState(null);

    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [pageloading, setPageLoading] = useState(false);

    const inputFileRef = useRef(null)


    useEffect(() => {
        setPageLoading(true)
        loadLanguages().then(languages => {

            //languages=languages.filter(x=> x.language !==16)
            setLanguages(sortLanguages(languages));
            setPageLoading(false)
        });



        if (id) {
            setPageLoading(true)
            loadCourse(id).then(course => {
                setNames(course.names)
                const t = course.talents && course.talents.length
                    ? course.talents
                    : course.talent != null
                    ? [course.talent]
                    : [];
                setTalents(t)
                setDates(course)
                setPageLoading(false)
                setStatus(course.status)
                setStaffPreview(!!course.staff_preview)
                setCourseImage(course.image ? mediaSrc(course.image, course.image) : null)
                setCountry(course.country);
            })
        }
    }, [])

    useEffect(() => {
        if (!languages?.length) return;
        const ids = new Set(languages.map((l) => l.id));
        setActiveLanguageTab((prev) => {
            if (prev != null && ids.has(prev)) return prev;
            return languages.find((l) => l.is_default)?.id ?? languages[0].id;
        });
    }, [languages]);

    const setDates = (course) => {

        if (!course.startdate || !course.enddate) return;
        const sd = course.startdate.split('-');
        const ed = course.enddate.split('-');


        setStartYear(sd[0])
        setStartMonth(sd[1])
        setStartDay(sd[2])
        var startdate = { year: parseInt(sd[0]), month: parseInt(sd[1]), day: parseInt(sd[2]) }
        var enddate = { year: parseInt(ed[0]), month: parseInt(ed[1]), day: parseInt(ed[2]) }

        setEndYear(ed[0])
        setEndMonth(ed[1])
        setEndDay(ed[2])

        setStartDate(startdate)
        setEndDate(enddate)



    }

    const handleNamesOnChange = (e) => {
        //alert(e.target.value)
        var language_id = e.target.getAttribute("language_id")

        var name = null;
        if (names) {
            name = names.find(x => x.language === parseInt(language_id));
        }
        if (name) {
            var temp_names = [...names];
            temp_names.find(x => x.language === parseInt(language_id)).name = e.target.value;
            setNames(temp_names)
        }
        else {

            var new_name = { name: e.target.value, description: "", language: parseInt(language_id) }
            var temp_namesa = [];
            if (names)
                temp_namesa = [...names, new_name];
            else temp_namesa = [new_name]
            setNames(temp_namesa)
        }
    }

    const handleDescriptionChange = (language_id, data) => {
        //alert(e.target.value)

        var name = null;
        if (names) {
            name = names.find(x => x.language === parseInt(language_id));
        }
        if (name) {
            var temp_names = [...names];
            temp_names.find(x => x.language === parseInt(language_id)).description = data;
            setNames(temp_names)
        }
        else if (!id) {

            var new_name = { name: "", description: data, language: parseInt(language_id) }
            var temp_namesa = [];
            if (names)
                temp_namesa = [...names, new_name];
            else temp_namesa = [new_name]
            setNames(temp_namesa)
        }
    }



    const onValue = (value, name) => {
        switch (name) {
          case "talents":
            setTalents(value || []);
            break;
          case "talent":
            setTalents(value != null ? [value] : []);
            break;
          case "country":
                setCountry(value);
            break;
          case "status":
            setStatus(value);
            break;
          case "staff_preview":
            setStaffPreview(!!value);
            break;
          case "startdate_year":
            var sd = startdate;
            sd.year = value;
            setStartDate(sd);
            setStartYear(value);
            break;
          case "startdate_month":
            var sd = startdate;
            sd.month = value;
            setStartDate(sd);
            setStartMonth(value);
            break;
          case "startdate_day":
            var sd = startdate;
            sd.day = value;
            setStartDate(sd);
            setStartDay(value);
            break;
          case "enddate_year":
            var sd = enddate;
            sd.year = value;
            setEndDate(sd);
            setEndYear(value);
            break;
          case "enddate_month":
            var sd = enddate;
            sd.month = value;
            setEndDate(sd);
            setEndMonth(value);
            break;
          case "enddate_day":
            var sd = enddate;
            sd.day = value;
            setEndDate(sd);
            setEndDay(value);
            break;

          default:
            break;
        }
    }

    const saveChanges = () => {

        setError(null);
        setLoading(true);

        if (!names || names[0].name.length < 3) {
            setError('Please Enter Name');
            setLoading(false);
            return;
        }

        if (!startdate.year || !startdate.month || !startdate.day) {
            setError('Please Select Start Date');
            setLoading(false);
            return;
        }
        if (!talents || talents.length === 0) {
            setError('Please select at least one talent');
            setLoading(false);
            return;
        }

        console.log(names)
        saveCourse({
          id: id,
          names: names,
          talents: talents,
          status: status,
          staff_preview: !!staffPreview,
          startdate: startdate,
          enddate: enddate,
          image: course_image,
          country: country,
        }).then(function (data) {
          setLoading(false);
          console.log(data);
          if (data.image) setCourseImage(mediaSrc(data.image, data.image));
          //history.push('/courses?success=true');
          //window.location.href = 'courses?success=true'
        });;
    }

    

    const fileChange = () => {
        inputFileRef.current.click();
    }

    const setSelectedImageGallery = (gallery_item) => {
        setCourseImage(gallery_item?.image ? mediaSrc(gallery_item.image, gallery_item.image) : null)
    }


    const openGallery = () => {

        setGalleryModalIsOpen(true)

    }

    const closeGallery = () => {
        setGalleryModalIsOpen(false)
    }

    


    return (
      <>
        <Gallery
          setSelectedGalleryItem={setSelectedImageGallery}
          isOpen={gallery_modal_is_open}
          key={gallery_modal_is_open}
          closeGallery={() => {
            closeGallery();
          }}
        />

        <div className="content-wrapper cms-course-edit-page">
          <section className="content-header" style={{ maxWidth: '1400px' }}>
            <h3 className="box-title mt-5" style={{ color: '#ccc', letterSpacing: '0.06em' }}></h3>
            <ol className="breadcrumb">
              <li>
                <a href="dashboard">
                  <i className="fa fa-dashboard"></i> Home
                </a>
              </li>
              <li>
                <a href="courses">Contest</a>
              </li>
              <li className="active">{id ? 'Edit' : 'Add'}</li>
            </ol>
          </section>

          <section className="content">
            <div className="row">
              <div className="col-md-12 ">
                <div className="box cms-dark-box no-border">
                  <div className="box-header with-border">
                    <h3 className="box-title">
                      {id && "Edit "} {!id && "Add New "} Competition
                    </h3>
                  </div>
                  <div className="box-body">
                    <div className=" ">
                      {pageloading && (
                        <>
                          <div className="overlay">
                            <i className="fas fa-2x fa-sync-alt fa-spin"></i>
                          </div>
                        </>
                      )}

                      <form className="form-horizontal">
                        <div>
                        <div className="col-md-7">
                            {languages && languages.length > 0 && activeLanguageTab != null && (
                              <>
                                <TabsWidget
                                  tabs={languages.map((l) => ({
                                    key: l.id,
                                    label: l.name,
                                  }))}
                                  activeTab={activeLanguageTab}
                                  onTabChange={setActiveLanguageTab}
                                  className="cms-page-tabs"
                                />
                                <div className="cms-page-tab-content">
                                  {languages
                                    .filter((l) => l.id === activeLanguageTab)
                                    .map((language) => (
                                      <div key={language.id}>
                                        <div className="form-row">
                                          <input
                                            type="text"
                                            name="name"
                                            className={`form-control mb-10 mxw-200${prefersKurdishFont(language.name) ? ' kfont' : ''}`}
                                            dir={usesRtlScript(language.name) ? 'rtl' : undefined}
                                            language_id={language.id}
                                            value={
                                              names &&
                                              names.find(
                                                (x) => x.language === language.id
                                              )
                                                ? names.find(
                                                    (x) =>
                                                      x.language === language.id
                                                  ).name
                                                : ""
                                            }
                                            onChange={handleNamesOnChange}
                                            placeholder={language.name}
                                          />
                                        </div>

                                        <div
                                          className={`form-row${prefersKurdishFont(language.name) ? ' kfont' : ''}${usesRtlScript(language.name) ? ' rtl' : ''}`}
                                          style={{ width: '100%', maxWidth: '100%' }}
                                        >
                                          <label className=""></label>
                                          <div className="" style={{ width: '100%', maxWidth: '100%' }}>
                                            <CKEditor
                                              editor={ClassicEditor}
                                              data={
                                                names &&
                                                names.find(
                                                  (x) =>
                                                    x.language === language.id
                                                )
                                                  ? names.find(
                                                      (x) =>
                                                        x.language === language.id
                                                    ).description
                                                    ? names.find(
                                                        (x) =>
                                                          x.language ===
                                                          language.id
                                                      ).description
                                                    : ""
                                                  : ""
                                              }
                                              onReady={(editor) => {
                                                // You can store the "editor" and use when it is needed.
                                              }}
                                              onChange={(event, editor) => {
                                                const data = editor.getData();
                                                handleDescriptionChange(
                                                  language.id,
                                                  data
                                                );
                                              }}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                </div>
                              </>
                            )}
                          </div>
                          <div className="col-md-5 pt-10">
                          <div className="form-group mx-0">
                              <img
                                className="img upload-img mb-5"
                                onClick={openGallery}
                                src={
                                  course_image
                                    ? mediaSrc(course_image, course_image)
                                    : "/assets/images/default.png"
                                }
                              />
                            </div>
                            <div className="form-group row mx-0">
                              <div className="">
                                <div className="custom-select-1 margin-r-10 mb-2">
                                  <SelectStatus
                                    width={"120px"}
                                    value={status}
                                    callback={onValue}
                                  />
                                </div>
                                <div className="custom-select-1 margin-r-10 mb-2">
                                  <label className="course-staff-preview-toggle">
                                    <input
                                      type="checkbox"
                                      checked={!!staffPreview}
                                      onChange={(e) => setStaffPreview(e.target.checked)}
                                    />
                                    <span className="course-staff-preview-toggle__copy">
                                      <span className="course-staff-preview-toggle__title">Staff preview</span>
                                      <span className="course-staff-preview-toggle__hint">
                                        Visible to admin, editor, referee, and test users while closed
                                      </span>
                                    </span>
                                  </label>
                                </div>
                                <div className="custom-select-1 margin-r-10">
                                  <SelectTalent
                                    border={"1"}
                                    width={"340px"}
                                    isMulti
                                    placeholder="Talents"
                                    value={talents}
                                    callback={onValue}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="form-group row mx-0">
                              <div className="">
                                <div className="custom-select-1 margin-r-10">
                                  <SelectCountries
                                    placeholder="Country"
                                    width={"220px"}
                                    value={country}
                                    callback={onValue}
                                  />
                                </div>
                              </div>
                            </div>
                            <hr className="cms-course-edit-hr" />
                            <div className="form-group mx-0">
                              <div className="">
                                <label className="cms-course-field-label">Start</label>
                              </div>
                              <div className="col-lg-12 padding-0">
                                <div className="custom-select-1 margin-r-10">
                                  <SelectYear
                                    future_only={0}
                                    width={"85px"}
                                    value={startdate && startdate.year}
                                    name={"startdate_year"}
                                    callback={onValue}
                                  />
                                  <div className="clear"></div>
                                </div>
                                <div className="custom-select-1 margin-r-10">
                                  <SelectMonth
                                    width={"85px"}
                                    value={startdate && startdate.month}
                                    name={"startdate_month"}
                                    callback={onValue}
                                  />
                                  <div className="clear"></div>
                                </div>
                                <div className="custom-select-1">
                                  <SelectDay
                                    width={"85px"}
                                    value={startdate && startdate.day}
                                    name={"startdate_day"}
                                    callback={onValue}
                                  />
                                  <div className="clear"></div>
                                </div>
                              </div>
                            </div>
                            <div className="form-group mx-0 mb-10">
                              <div className="">
                                <label className="cms-course-field-label">End</label>
                              </div>
                              <div className=" col-lg-12 padding-0 ">
                                <div className="custom-select-1 margin-r-10">
                                  <SelectYear
                                    future_only={0}
                                    width={"85px"}
                                    value={enddate && enddate.year}
                                    callback={onValue}
                                    name="enddate_year"
                                  />
                                </div>
                                <div className="custom-select-1 margin-r-10">
                                  <SelectMonth
                                    width={"85px"}
                                    value={enddate && enddate.month}
                                    name={"enddate_month"}
                                    callback={onValue}
                                  />
                                </div>
                                <div className="custom-select-1">
                                  <SelectDay
                                    width={"85px"}
                                    value={enddate && enddate.day}
                                    name={"enddate_day"}
                                    callback={onValue}
                                  />
                                </div>
                              </div>
                            </div>

                            
                          </div>

                         
                        </div>
                      </form>
                    </div>
                  </div>

                  <div className="box-footer">
                    {id && (
                      <a href="courses" className="btn btn-default">
                        Cancel
                      </a>
                    )}

                    {isAdmin() && (
                      <button
                        type="button"
                        onClick={saveChanges}
                        disabled={loading}
                        className="btn btn-primary pull-right"
                      >
                        Save Changes
                      </button>
                    )}
                  </div>

                  {error && (
                    <>
                      <div className="alert alert-danger">{error}</div>
                    </>
                  )}

                  {loading && (
                    <>
                      <div className="alert alert-info">please wait...</div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </section>
        </div>
      </>
    );

}
